export default "__VITE_ASSET__BEvMkYjn__"